import * as Yup from 'yup'

export const schema = Yup.object().shape({
  ticket_team_id: Yup.string(),
  name: Yup.string().required('ticket category name is required'),
});